<!-- Hors production : la barre qui dit sur quel environnement on travaille. -->
<app-env-banner />
<router-outlet></router-outlet>
